import React, {useContext, useEffect, useState} from 'react'
import {withRouter} from 'react-router-dom'
import {Page_settings} from '../../config/page_settings'
import strings from '../../lang/strings'
import {observer} from 'mobx-react'
import AppInput from '../../components/control/custom_input/app_input'
import ConfirmButton from '../../components/control/button/confirm_button'
import PageSubHeader from '../../components/common/page_sub_header'
import PerfectScrollbar from 'react-perfect-scrollbar'
import TableHeaderPrimary from '../../components/control/table/table_header_primary'
import TableCell from '../../components/control/table/table_cell'
import TableCellGameCategory from '../../components/control/table/table_cell_game_category'
import TableCellGameRate from '../../components/control/table/table_cell_game_rate'
import CKEditor from '@ckeditor/ckeditor5-react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import {API_URL, IsDev} from '../../config/const'
import {ceil, chkNoteTitle, chkTitle, customDateFormat, formatNumber} from '../../helper/common'
import {rootStore} from '../../mobx/store'
import DropdownGameNotice from '../../components/dropdown/game_notice'
import TableCellGameTeam from '../../components/control/table/table_cell_game_team'
import EmojiInput from '../../components/control/custom_input/emoji_input'

const AnalystNewDaily = observer((props) => {
  const data = props.location.state.data
  const context = useContext(Page_settings)
  let [title, setTitle] = useState('')
  let [content, setContent] = useState('')
  let [enabled, setEnabled] = useState(false)
  let [datMode, setDateMode] = useState(1)
  let [yearList, setYearList] = useState([])
  let [roundList, setRoundList] = useState([])
  let [kindList, setKindList] = useState([])
  let [roundListAll, setRoundListAll] = useState([])
  let [year, setYear] = useState(0)
  let [round, setRound] = useState(0)
  let [kind, setKind] = useState(0)

  const gameTypeList = [strings.normal, strings.handycup, strings.endover, strings.win1loss, strings.evenorodd, strings.firsthalf]
  let [gameDataList, setGameDataList] = useState([])

  const tbHeaders = [
    {
      name: strings.number,
      class: 'td-pro-game-num',
    },
    {
      name: strings.end_date,
      class: 'td-pro-game-end-date',
    },
    {
      name: strings.category_turn,
      class: 'td-pro-game-ca-tu',
    },
    {
      name: strings.game_type,
      class: 'td-pro-game-ty',
    },
    {
      name: strings.team_vs,
      class: 'td-pro-game-teams',
      is_team: true
    },
    {
      name: strings.choose_rate,
      class: 'td-pro-game-rate',
    },
    {
      name: strings.game_date,
      class: 'td-pro-game-end-date',
    },
  ]

  useEffect(() => {
    if (data) {
      setTitle(data.dat_title)
      if (data.other_purchased == 0) setContent(data.dat_note)
      setDateMode(parseInt(data.dat_mode))
      setYear(data.dat_s_year)
      setKind(data.dat_s_kind)
    }
    initPicker()
  }, [])

  useEffect(() => {
    if (data && data.other_purchased == 1) {
      setEnabled(true)
      return
    }
    setEnabled(title !== '' && content !== '')
  }, [title, content])

  const initPicker = () => {
    context.post('data/sport_list', {dat_id: (data && data.other_purchased == 1) ? data.dat_id : 0},
      response => {
        const yearL = response.year
        if (yearL.length === 0) return
        const yearT = data ? data.dat_s_year : yearL[0].year
        const roundL = response.round
        const roundL1 = roundL.filter((item) => {return item.year == yearT})
        if (roundL1.length === 0 || roundL1[0].round.length === 0) return
        const roundT = data ? data.dat_s_round : roundL1[0].round[0].round
        setYear(yearT)
        setYearList(yearL)
        setRoundListAll(roundL)
        setRoundList(roundL1[0].round)
        setRound(roundT)
        const kindL = response.kind
        const kindT = data ? data.dat_s_kind : kindL[0].sk_id
        setKindList(kindL)
        setKind(kindT)
        initData(yearT, roundT, kindT, true)
      }
    )
  }

  const initData = (year, round, kind, init = false) => {
    context.post('data/get_toto_list', {year: year, round: round, sport: kind, dat_id: (data && data.other_purchased == 1) ? data.dat_id : 0},
      response => {
        let list = response.list
        if (init && data) {
          context.post('data/game_list', {uid: data.dat_id},
            res => {
              let game_list = res.game_list
              for (let i = 0; i < list.length; i++) {
                let gameT = game_list.filter((item) => {return item.id === list[i].id})
                if (gameT.length > 0) {
                  if (gameT[0].dg_i_win == 1) {
                    list[i].sel = 0
                  } else if (gameT[0].dg_i_tie == 1) {
                    list[i].sel = 1
                  } else if (gameT[0].dg_i_loss == 1) {
                    list[i].sel = 2
                  } else {
                    list[i].sel = -1
                  }
                }
              }
              setGameDataList(list)
            }
          )
        } else {
          setGameDataList(list)
        }
      }
    )
  }

  const selectYear = (year) => {
    setYear(year)
    const roundL = roundListAll.filter((item) => {return item.year == year})
    if (roundL.length === 0 || roundL[0].round.length === 0) {
      setGameDataList([])
      return
    }
    const roundT = roundL[0].round[0].round
    setRoundList(roundL[0].round)
    setRound(roundT)
    initData(year, roundT, kind)
  }

  const getGameTypeClass = (type) => {
    if (type == 1) {
      return 'color-e45a5a'
    } else if (type == 2) {
      return 'color-3a6d99'
    } else if (type == 3) {
      return 'color-9c39cf'
    } else {
      return 'color-3a3335'
    }
  }

  const onRateChange = (val, index) => {
    if (data && data.other_purchased == 1) return
    const game = gameDataList[index]
    const hit = val === 0 ? game.home_dividend_rate : (val === 1 ? game.no_odds : game.away_dividend_rate)
    if (hit < 1.6) return
    setGameDataList(prev => prev.map((it, idx) => {
      if (idx === index) {
        it.sel = it.sel === val ? -1 : val
      } else {
        it.sel = -1
      }
      return it
    }))
  }

  const handleTitle = (e) => {
    setTitle(chkNoteTitle(e))
  }

  const drawTableNumCell = (info) => {
    if (info.btm_noticeNo == 0) return null
    return (
      <div className='w-100'>
        <DropdownGameNotice clickMethod={() => onPopup(info)}/>
        <div className='w-100 text-center'>{info.btm_match_seq}</div>
      </div>
    )
  }

  const onPopup = (info) => {
    if (IsDev) {
      rootStore.setGameNotice(info.btm_noticeNo)
      return
    }
    rootStore.setGameNotice(null)
    if (info.notice) {
      rootStore.setGameNotice(info.notice)
      return
    }
    context.post('toto/syncGameNotice', {gameSeq: info.btm_match_seq, gmId: info.btm_game_id, gmTs: info.btm_game_ts, seqNo: info.btm_noticeNo},
      response => {
        response = response.replace(/<br\/><br\/>/g, '').replace(/\r<br>/g, '')
        info.notice = response
        rootStore.setGameNotice(response)
      }
    )
  }

  const onSave = () => {
    if (!enabled) return
    if (data && data.other_purchased == 1) {
      context.post('data/an_new', {uid: data.dat_id, cate: 6, title: title, content: data.dat_note + content, modify: 1},
        () => {
          context.showAlert(strings.bj_data_modified, function () {
            props.history.replace('/my_data')
          }, strings.confirm)
        },
        true,
        err => {
          context.showAlert(err.msg)
        }
      )
      return
    }
    let selList = gameDataList.filter((item) => {return item.sel > -1})
    if (selList.length === 0) {
      context.showAlert(strings.select_data)
      return
    }
    let list = []
    let start = ''
    let bae = 1
    for (let i = 0; i < selList.length; i++) {
      let item = selList[i]
      if (start === '' || start > item.round_end) start = item.round_end
      bae *= parseFloat(item.sel === 0 ? item.home_dividend_rate : item.sel === 1 ? item.no_odds : item.away_dividend_rate)
      list.push({id: item.id, kind: item.sport_id, win: item.sel === 0 ? 1 : 0, tie: item.sel === 1 ? 1 : 0, loss: item.sel  === 2 ? 1 : 0})
    }
    bae = ceil(bae)
    context.post('data/an_new', {uid: data ? data.dat_id : 0, cate: 6, dat_mode: datMode, title: title, content: content, year: year, round: round, kind: kind, game: JSON.stringify(list), game2: JSON.stringify([]), start: start, bae: bae},
      () => {
        context.showAlert(data ? strings.bj_data_modified : strings.bj_data_registered, function () {
          props.history.replace('/my_data')
        }, strings.confirm)
      },
      true,
      err => {
        context.showAlert(err.msg)
      }
    )
  }

  return (
    <React.Fragment>
      <div className='content-container'>
        <div className='im-container im-container-no-sidebar'>
          <PageSubHeader pageName={strings.daily_special} pageMenu1={strings.main} pageMenu2={strings.my_analyst} pageMenu={strings.daily_special}/>
          <div className='al-header mt-30 sm-mt-15 fs-18 sm-fs-16 f-b'>{strings.analyst_article}</div>
          <div className='al-content'>
            <label className='control-label'>{strings.option}</label>
            <select disabled={data && data.other_purchased == 1} className='form-control select-betting' value={datMode} onChange={(e) => { setDateMode(e.target.value)}}>
              <option value={1}>{strings.mode_victory1}[{formatNumber(rootStore.getMe.price6) + strings.point}]</option>
              <option value={2}>{strings.mode_victory2}[{formatNumber(rootStore.getMe.price7) + strings.point}]</option>
              <option value={3}>{strings.mode_victory3}[{formatNumber(rootStore.getMe.price8) + strings.point}]</option>
            </select>
            <label className='control-label mt-20'>{strings.title}<span className='text-danger'>*</span></label>
            <EmojiInput disable={data && data.other_purchased == 1} className={''} errorMsg={''} placeholder={strings.title_hint} inputType={'text'} maxLength={30} value={title} onChange={setTitle} />
            <label className='control-label mt-20 sm-mt-18'>{strings.analyst_content}<span className='text-danger'>*</span></label>
            {(data && data.other_purchased == 1) && <div className='bj-note mb-20 fs-16 sm-fs-14' dangerouslySetInnerHTML={{ __html: data.dat_note }} />}
            <CKEditor
              editor={ClassicEditor}
              data={content}
              config={{
                ckfinder: {
                  uploadUrl: API_URL + '/api/upload/upload_file'
                },
                removePlugins: ['ImageUpload', 'ImageEditing', 'ImageCaption'],
                placeholder: strings.data_new_input
              }}
              onChange={(event, editor) => {
                setContent(editor.getData())
              }}
            />
          </div>
          <div className={'data-filter-area d-flex mt-12 sm-mt-15 pl-40 sm-pl-18'}>
            <select disabled={data && data.other_purchased == 1} className='data-filter-select pr-60 sm-pr-8 fs-16 sm-fs-14 f-sb' value={year} onChange={(e) => {selectYear(e.target.value)}}>
              {yearList.map((it, idx) => {return (<option value={it.year} key={idx}>{it.year}{strings.year}</option>)})}
            </select>
            <select disabled={data && data.other_purchased == 1} className='data-filter-select mh-60 sm-mh-12 pr-60 sm-pr-8 fs-16 sm-fs-14 f-sb' value={round} onChange={(e) => {setRound(e.target.value); initData(year, e.target.value, kind)}}>
              {roundList.map((it, idx) => {return (<option value={it.round} key={idx}>{it.round}{strings.times}</option>)})}
            </select>
            <select disabled={data && data.other_purchased == 1} className='data-filter-select pr-60 sm-pr-8 fs-16 sm-fs-14 f-sb' value={kind} onChange={(e) => {setKind(e.target.value); initData(year, round, e.target.value)}}>
              {kindList.map((it, idx) => {return (<option value={it.sk_id} key={idx}>{it.sk_name}</option>)})}
            </select>
          </div>
          <div className='analyst_register p-40 sm-ph-15 sm-pb-0'>
            <div className='d-flex mb-12 sm-mb-5 align-items-center w-100 analyst_type'>
              <img className='' src={'/assets/image/chk4_on.png'} height={18} alt='' />
              <div className='fs-16 f-m color-3a3335 ml-6 pt-2'>{strings.hit_coincidence}</div>
              <img className='ml-20' src={'/assets/image/chk4_off.png'} height={18} alt='' />
              <div className='fs-16 f-m color-3a3335 ml-6 pt-2'>{strings.choose_area}</div>
              <img className='ml-20' src={'/assets/image/chk4.png'} height={18} alt='' />
              <div className='fs-16 f-m color-3a3335 ml-6 pt-2'>{strings.hit_result}</div>
            </div>
            <div className='shadow-div position-relative'>
              <PerfectScrollbar className='div_sale sm-mt-20 ps-x div_game'>
                <TableHeaderPrimary className={''} headers={tbHeaders}/>
                {
                  gameDataList.map((info, index) => {
                    let sk = kindList.filter((item) => {return item.sk_id == info.sport_id})
                    let sk_icon = sk.length > 0 ? sk[0].sk_icon: 's_football.png'
                    return (
                      <div key={index} className={'tb-row-primary' + (info.disable ? ' tb-row-disabled' : '')}>
                        <TableCell
                          value={info.btm_match_seq}
                          className={tbHeaders[0].class + ' td-cell-primary'}
                          center={tbHeaders[0].center}
                          child={drawTableNumCell(info)}
                        />
                        <TableCell
                          value={customDateFormat(info.round_end, true)}
                          className={tbHeaders[1].class + ' td-cell-primary'}
                          center={tbHeaders[1].center}
                          child={null}
                        />
                        <TableCellGameCategory
                          icon={sk_icon}
                          league={info.league_name}
                          kind={kindList}
                          className={tbHeaders[2].class + ' td-cell-primary'}
                          center={tbHeaders[2].center}
                          child={null}
                        />
                        <TableCell
                          value={gameTypeList[info.betting_type]}
                          className={tbHeaders[3].class + ' td-cell-primary'}
                          center={tbHeaders[3].center}
                          child={
                            <div className={'w-100 text-center fs-16 sm-fs-14 f-m ' + getGameTypeClass(info.betting_type)}>{gameTypeList[info.betting_type]}</div>
                          }
                        />
                        <TableCellGameTeam
                          home={info.home_name}
                          away={info.away_name}
                          handi={info.handicap_standard}
                          uo={info.uo_standard}
                          className={tbHeaders[4].class + ' td-cell-primary'}
                          center={tbHeaders[4].center}
                          child={null}
                        />
                        <TableCellGameRate
                          selected={info.sel}
                          ans={-1}
                          type={info.betting_type}
                          home_rate={info.home_dividend_rate}
                          no_rate={info.no_odds}
                          away_rate={info.away_dividend_rate}
                          className={tbHeaders[5].class + ' td-cell-primary'}
                          onChange={(val) => {
                            onRateChange(val, index)
                          }}
                        />
                        <TableCell
                          value={customDateFormat(info.round_start, true)}
                          className={tbHeaders[6].class + ' td-cell-primary'}
                          center={tbHeaders[6].center}
                          child={null}
                        />
                      </div>
                    )
                  })
                }
              </PerfectScrollbar>
            </div>
          </div>
          <ConfirmButton enabled={enabled} className={'btn btn-login mt-60 sm-mt-30 fs-15 sm-fs-14 f-m '} onClick={() => onSave()} text={data ? strings.do_modify : strings.make} />
        </div>
      </div>
    </React.Fragment>
  )
})

export default withRouter(AnalystNewDaily)
